(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["catering-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('country-select')) {
    class CountrySelect extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.trigger = this.querySelector('.catering-form__combo-trigger');
        this.panel = this.querySelector('.catering-form__combo-panel');
        this.search = this.querySelector('.catering-form__combo-search');
        this.list = this.querySelector('.catering-form__combo-list');
        if (!this.select || !this.trigger || !this.panel) return;

        this.options = Array.from(this.select.options)
          .filter((o) => o.value !== '')
          .map((o) => ({ value: o.value, label: o.textContent.trim() }));

        this.activeIndex = 0;
        this.visible = this.options;

        this.trigger.hidden = false;
        this.classList.add('is-ready');
        this.updateLabel();

        this.trigger.addEventListener('click', () => (this.isOpen ? this.close() : this.open()));
        this.search.addEventListener('input', () => this.filter());
        this.search.addEventListener('keydown', (e) => this.onKey(e));
        this.trigger.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.open();
          }
        });
        this.list.addEventListener('click', (e) => {
          const li = e.target.closest('li[data-value]');
          if (li) this.choose(li.dataset.value);
        });
        this.list.addEventListener('mousemove', (e) => {
          const li = e.target.closest('li[data-value]');
          if (!li) return;
          const i = this.visible.findIndex((o) => o.value === li.dataset.value);
          if (i !== -1 && i !== this.activeIndex) this.setActive(i, false);
        });

        this.onDocClick = (e) => {
          if (!this.contains(e.target)) this.close();
        };
        document.addEventListener('click', this.onDocClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
      }

      get isOpen() {
        return !this.panel.hidden;
      }

      open() {
        this.panel.hidden = false;
        this.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.search.value = '';
        this.visible = this.options;
        this.render();
        const selectedIndex = this.visible.findIndex((o) => o.value === this.select.value);
        this.setActive(selectedIndex > -1 ? selectedIndex : 0);
        this.search.focus();
      }

      close() {
        if (!this.isOpen) return;
        this.panel.hidden = true;
        this.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
      }

      filter() {
        const q = this.search.value.trim().toLowerCase();
        this.visible = q ? this.options.filter((o) => o.label.toLowerCase().includes(q)) : this.options;
        this.render();
        this.setActive(0);
      }

      render() {
        this.list.innerHTML = '';
        if (!this.visible.length) {
          const empty = document.createElement('li');
          empty.className = 'catering-form__combo-empty';
          empty.textContent = 'No countries found';
          this.list.appendChild(empty);
          return;
        }
        const frag = document.createDocumentFragment();
        this.visible.forEach((o) => {
          const li = document.createElement('li');
          li.setAttribute('role', 'option');
          li.dataset.value = o.value;
          li.textContent = o.label;
          li.setAttribute('aria-selected', o.value === this.select.value ? 'true' : 'false');
          frag.appendChild(li);
        });
        this.list.appendChild(frag);
      }

      setActive(index, scroll = true) {
        const items = this.list.querySelectorAll('li[data-value]');
        if (!items.length) return;
        this.activeIndex = Math.max(0, Math.min(index, items.length - 1));
        items.forEach((li, i) => li.classList.toggle('is-active', i === this.activeIndex));
        if (scroll) items[this.activeIndex].scrollIntoView({ block: 'nearest' });
      }

      onKey(e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          this.setActive(this.activeIndex + 1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          this.setActive(this.activeIndex - 1);
        } else if (e.key === 'Enter') {
          e.preventDefault();
          const o = this.visible[this.activeIndex];
          if (o) this.choose(o.value);
        } else if (e.key === 'Escape') {
          e.preventDefault();
          this.close();
          this.trigger.focus();
        } else if (e.key === 'Tab') {
          this.close();
        }
      }

      choose(value) {
        this.select.value = value;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
        this.updateLabel();
        this.close();
        this.trigger.focus();
      }

      updateLabel() {
        const opt = this.select.selectedOptions[0];
        const label = this.trigger.querySelector('[data-label]');
        label.textContent = opt && opt.value ? opt.textContent.trim() : 'Select country';
      }
    }

    customElements.define('country-select', CountrySelect);
  }
  } catch(e) { console.error(e); }
})();

})();
